import { TextField, Typography, Container, Button ,InputAdornment } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { signUp } from '../../Actions/Auth';
import { useNavigate } from 'react-router-dom';
import PasswordIcon from '@mui/icons-material/Password';
import EmailIcon from '@mui/icons-material/Email';
import { toast } from 'react-toastify';
import { contactUs } from '../../Actions/ContactUs';


const ContactUsForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const em = /^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@srmist.edu.in$/;
  const num = /^[0-9]+$/;

  const validate = Yup.object().shape({
    name: Yup.string().min(2, 'Too Short!').max(30, 'Too Long!').required('Required'),
    phoneNumber: Yup.string()
      .matches(phoneRegExp, 'Phone Number is not valid')
      .min(10, 'Too Short!')
      .max(10, 'Too Long!')
      .required('Required'),
  
    query: Yup.string().required('Required'),
    designation: Yup.string().min(1, 'Too Short!').max(30, 'Too Long!').required('Required'),
    email: Yup.string().matches(em, 'This is not an SRM email').email('Invalid email').required('Required'),
   
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      query: '',
      email: '',
      designation:'',
      phoneNumber:'',

      
    },
    validationSchema: validate,
    onSubmit: (values, onSubmitProps) => {
      dispatch(
        contactUs(
          {
            name: values.name,
            email: values.email,
            query: values.query,
            designation:values.designation,
            phoneNumber:values.phoneNumber,
            
          },
         
        ),
      );

      // setOpen(true);
      onSubmitProps.resetForm();
      // toast('Thank you for contacting us , We will get back to you soon...')
    },
  });

  return (
    <Container
      sx={{
        width: '100%',
        height: ['100%', '100%', '100%'],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 10,
        marginBottom: '150px',
      }}
    >
      <Container
        sx={{
          width: ['90%', '60%', '60%'],
          height: ['100%', '100%', '110%'],
          boxShadow: '0px 3px 45px #71380C12',
          marginTop: ['0px', '0px', '20px'],
          backgroundColor: '#FCFCFC',
          // border: 2,
          // borderRadius: 10,
          paddingBottom: 2,
        }}
      >
        <Typography sx={{ marginTop: '20px', font: 'normal normal 600 30px/46px Poppins', px: 3 }} variant="h5">
          Contact Us<span style={{ color: '#FF7345' }}> For Any Query</span>
        </Typography>

        <form style={{ width: '100%' }} onSubmit={formik.handleSubmit}>
          <Container
            sx={{
              display: 'flex',
              flexDirection: ['column', 'column', 'row'],
              flexWrap: 'wrap',
              justifyContent: ['center', 'center', 'space-between'],
            }}
          >
            <TextField
              placeholder="Enter your name"
              id="name"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              InputProps={{
                disableUnderline: true,
              }}
              sx={{
                marginTop: '30px',
                backgroundColor: '#F6F7F9',
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height: '40px',
                paddingLeft: '15px',
                paddingTop: '7px',
                '& input::placeholder': {
                  font: 'normal normal normal 15px/23px Poppins',
                },
                outlineColor: '#FF7345',
              }}
              variant="standard"
            />
            {/* <TextField
              id="empID"
              name="empID"
              placeholder="Employee Id"
              value={formik.values.empID}
              onChange={formik.handleChange}
              error={formik.touched.empID && Boolean(formik.errors.empID)}
              helperText={formik.touched.empID && formik.errors.empID}
              InputProps={{
                disableUnderline: true,
              }}
              sx={{
                marginTop: '30px',
                backgroundColor:"#F6F7F9",
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height:"40px",
                paddingLeft:"5px",
                paddingTop:"3px",
                '& input::placeholder': {
                  fontFamily: 'Poppins',
                  fontSize: '15px'
                },
                outlineColor: '#FF7345',
              }}
              variant='standard'
            /> */}
            {/* <TextField
              id="department"
              name="department"
              placeholder="Department"
              value={formik.values.department}
              onChange={formik.handleChange}
              error={formik.touched.department && Boolean(formik.errors.department)}
              helperText={formik.touched.department && formik.errors.department}
              // error="This is error"
              // helperText="There is error
             InputProps={{
                disableUnderline: true,
              }}
              sx={{
                marginTop: '30px',
                backgroundColor:"#F6F7F9",
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height:"40px",
                paddingLeft:"5px",
                paddingTop:"3px",
                '& input::placeholder': {
                  fontFamily: 'Poppins',
                  fontSize: '15px'
                },
                outlineColor: '#FF7345',
              }}
              variant='standard'
            /> */}
            <TextField
              id="designation"
              name="designation"
              placeholder="Designation"
              value={formik.values.designation}
              onChange={formik.handleChange}
              error={formik.touched.designation && Boolean(formik.errors.designation)}
              helperText={formik.touched.designation && formik.errors.designation}
              // error="This is error"
              // helperText="There is error
              InputProps={{
                disableUnderline: true,
              }}
              sx={{
                marginTop: '30px',
                backgroundColor: '#F6F7F9',
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height: '40px',
                paddingLeft: '15px',
                paddingTop: '7px',
                '& input::placeholder': {
                  font: 'normal normal normal 15px/23px Poppins',
                },
                outlineColor: '#FF7345',
              }}
              variant="standard"
            />
            <TextField
              id="email"
              name="email"
              placeholder="Enter your Email Id"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              // error="This is error"
              // helperText="There is error
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <EmailIcon sx={{ mx: 1 }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                marginTop: '30px',
                backgroundColor: '#F6F7F9',
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height: '40px',
                paddingLeft: '15px',
                paddingTop: '7px',
                '& input::placeholder': {
                  font: 'normal normal normal 15px/23px Poppins',
                },
                outlineColor: '#FF7345',
              }}
              variant="standard"
            />
            {/* <TextField
              id="altemail"
              name="altemail"
              placeholder="Alternate Email"
              value={formik.values.altemail}
              onChange={formik.handleChange}
              error={formik.touched.altemail && Boolean(formik.errors.altemail)}
              helperText={formik.touched.altemail && formik.errors.altemail}
              // error="This is error"
              // helperText="There is error
             InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <EmailIcon sx={{mx:1}}/>
                  </InputAdornment>
                ),
              }}
              sx={{
                marginTop: '30px',
                backgroundColor:"#F6F7F9",
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height:"40px",
                paddingLeft:"5px",
                paddingTop:"3px",
                '& input::placeholder': {
                  fontFamily: 'Poppins',
                  fontSize: '15px'
                },
                outlineColor: '#FF7345',
              }}
              variant='standard'
            />
            <TextField
              id="password"
              name="password"
              type="password"
              placeholder="Password"
              value={formik.values.password}
              onChange={formik.handleChange}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              // error="This is error"
              // helperText="There is error
             InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <PasswordIcon sx={{mx:1}}/>
                  </InputAdornment>
                ),
              }}
              sx={{
                marginTop: '30px',
                backgroundColor:"#F6F7F9",
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height:"40px",
                paddingLeft:"5px",
                paddingTop:"3px",
                '& input::placeholder': {
                  fontFamily: 'Poppins',
                  fontSize: '15px'
                },
                outlineColor: '#FF7345',
              }}
              variant='standard'
            ></TextField>
            <TextField
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              placeholder="Confirm Password"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
              helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
              // error="This is error"
              // helperText="There is error
             InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <PasswordIcon sx={{mx:1}}/>
                  </InputAdornment>
                ),
              }}
              sx={{
                marginTop: '30px',
                backgroundColor:"#F6F7F9",
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height:"40px",
                paddingLeft:"5px",
                paddingTop:"3px",
                '& input::placeholder': {
                  fontFamily: 'Poppins',
                  fontSize: '15px'
                },
                outlineColor: '#FF7345',
              }}
              variant='standard'
            /> */}
            <TextField
              id="phoneNumber"
              name="phoneNumber"
              placeholder="Enter Your Phone Number"
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
              error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
              helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
              InputProps={{
                disableUnderline: true,
              }}
              sx={{
                marginTop: '30px',
                backgroundColor: '#F6F7F9',
                width: ['100%', '100%', '47%'],
                borderRadius: '5px',
                height: '40px',
                paddingLeft: '15px',
                paddingTop: '7px',
                '& input::placeholder': {
                  font: 'normal normal normal 15px/23px Poppins',
                },
                outlineColor: '#FF7345',
              }}
              variant="standard"
            />{' '}
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <TextField
                placeholder="Enter your message..."
                id="query"
                name="query"
                value={formik.values.query}
                onChange={formik.handleChange}
                error={formik.touched.query && Boolean(formik.errors.query)}
                helperText={formik.touched.query && formik.errors.query}
                variant="standard"
                // placeholder="Enter Your Project Description*"

                sx={{
                  marginTop: '30px',
                  width: ['100%', '100%', '100%'],
                  height: '100px',
                  borderRadius: 2,
                  paddingLeft: '15px',
                  paddingTop: '7px',
                  // backgroundColor: 'white',
                  height: '100px',
                  // p: 1,
                  backgroundColor: '#F6F7F9',
                  outlineColor: '#FF7345',
                  '& input::placeholder': {
                    font: 'normal normal normal 15px/23px Poppins',
                  },
                  // marginTop: '30px',
                  // backgroundColor: '#F6F7F9',
                  // width: ['100%', '100%', '100%'],
                  // borderRadius: '5px',
                  // height: '100%',
                  // paddingLeft: '15px',
                  // paddingTop: '7px',
                  // '& input::placeholder': {
                  //   fontFamily: 'Poppins',
                  //   fontSize: '15px',
                  // },
                  // outlineColor: '#FF7345',
                }}
                multiline
                maxRows="4"
                minRows="2"
                InputProps={{
                  disableUnderline: true,

                  // style: { color: "#703C00" },
                }}
              />
            </div>
            <Button
              variant="contained"
              sx={{
                width: '100%',
                height: '35px',
                marginTop: '50px',
                paddingTop: '5px',
                paddingBottom: '5px',
                backgroundColor: '#FF7345',
                boxShadow:'none',
                
                '&:hover': {
                  backgroundColor: '#d95429',
                },
              }}
              type="submit"
              disableElevation='true'
            >
              SUBMIT
            </Button>
          </Container>
        </form>
      </Container>
    </Container>
  );
};
export default ContactUsForm;
